import React from 'react';
import classNames from 'classnames';
import { Button, ButtonTextTransform, ButtonType } from 'swag-client-common/components/ui/button';
import { PRODUCTION_MOCKUP_STATUSES } from 'swag-common/constants/order-statuses.constants';
import { STATE_LOADING } from '../../../../../redux/redux.constants';
import CustomPdfViewer from '../custom-pdf-viewer';
import classes from './approve-mockup.scss';
export const ApproveMockup = ({
  onEditChangeRequest,
  onRequestChangesSubmit,
  onRequestChanges,
  mockup,
  itemId,
  orderId,
  requestChangesState,
  onApproveSubmit,
  state,
  isRequestingChanges,
  isPdf,
  isDisabled,
  shouldUpdateInHandDate
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.approveMockupWrapper
}, /*#__PURE__*/React.createElement("h2", {
  className: classes.title
}, "Mockup approval"), /*#__PURE__*/React.createElement("div", {
  className: classNames(classes.viewerWrapper, isPdf && classes.pdfWrapper)
}, isPdf ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CustomPdfViewer, {
  file: mockup.fileName
}), /*#__PURE__*/React.createElement("a", {
  className: classes.link,
  target: "_blank",
  rel: "noreferrer",
  href: mockup.fileName
}, "Download PDF")) : /*#__PURE__*/React.createElement("img", {
  className: classes.mockup,
  src: mockup.fileName
})), isRequestingChanges && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
  className: classes.textareaWrapper
}, /*#__PURE__*/React.createElement("textarea", {
  placeholder: "Enter your feedback",
  className: classes.changesInput,
  onChange: onEditChangeRequest,
  value: mockup.changeRequest,
  "data-input": "MockupFeedback"
})), shouldUpdateInHandDate && /*#__PURE__*/React.createElement("div", {
  className: classes.inHandDateChangeMessage
}, "It will take up to 3 business days for us to get a revised production mockup to you. This revision will delay the delivery date of your order by a few business days, so please plan to review and approve your updated production mockup as soon as you receive it. We will provide an updated delivery date for your order as soon as it is available.")), !isDisabled && /*#__PURE__*/React.createElement("div", {
  className: classes.buttonsContainer
}, isRequestingChanges ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
  onClick: onRequestChanges(false),
  type: ButtonType.defaultGrey,
  className: classes.requestChangesButton,
  dataButton: "CancelRevisions",
  textTransform: ButtonTextTransform.none
}, "Cancel Revisions"), /*#__PURE__*/React.createElement(Button, {
  onClick: onRequestChangesSubmit({
    mockup,
    orderId,
    itemId,
    status: PRODUCTION_MOCKUP_STATUSES.DECLINED_BY_CUSTOMER
  }),
  type: "primary",
  loading: requestChangesState === STATE_LOADING,
  dataButton: "SubmitRequest",
  textTransform: ButtonTextTransform.none
}, "Submit Revisions")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
  onClick: onRequestChanges(true),
  className: classes.requestChangesButton,
  dataButton: "RequestRevisions",
  textTransform: ButtonTextTransform.none,
  type: ButtonType.defaultGrey
}, "Request Revisions"), /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  onClick: onApproveSubmit({
    mockup,
    orderId,
    itemId,
    status: PRODUCTION_MOCKUP_STATUSES.APPROVED_BY_CUSTOMER
  }),
  loading: state === STATE_LOADING,
  dataButton: "ApproveMockup",
  textTransform: ButtonTextTransform.none
}, "Approve"))));